module.exports = __webpack_public_path__ + "img/bed-solid.de7e43bd.svg";